import type { BackgroundJob } from "@metalmind-ab/mmagent-chat-ui";
import type { ActiveConversationJobSummary } from "./conversationMessageWindow";

interface BackgroundJobStoreActions {
  add: (job: BackgroundJob) => void;
  update: (jobId: string, updates: Partial<BackgroundJob>) => void;
}

/** Restore the active-job snapshot into the in-memory store without duplicates. */
export function upsertActiveConversationJobs(
  summaries: ActiveConversationJobSummary[],
  existingJobs: BackgroundJob[],
  actions: BackgroundJobStoreActions,
): boolean {
  let valid = true;
  const existingJobIds = new Set(existingJobs.map((job) => job.jobId));
  for (const summary of summaries) {
    if (summary.status !== "pending" && summary.status !== "running") {
      valid = false;
      continue;
    }
    const job: BackgroundJob = {
      jobId: summary.jobId,
      skillName: summary.kind,
      status: summary.status,
      progress: summary.progress ?? 0,
    };
    if (existingJobIds.has(job.jobId)) {
      actions.update(job.jobId, job);
    } else {
      actions.add(job);
      existingJobIds.add(job.jobId);
    }
  }
  return valid;
}
